export default "__VITE_ASSET__DnI2Bq9l__"